export default function isBlank(value: string | number | null): boolean {
  return (
    value === null || (typeof value === 'string' && value.trim().length === 0)
  );
}
